import { SubscriptionStatus } from '@/services/subscription-service'

export const SUBSCRIPTION_INVALID_STATUS: SubscriptionStatus[] = [
  'past_due',
  'unpaid',
  'incomplete',
  'incomplete_expired',
]

export enum PlanType {
  STARTER = 'starter',
  PRO = 'pro',
  PRO_PLUS_VOICE = 'pro-plus-voice',
  APPSUMO_TIER_1 = 'appsumo-tier-1',
  APPSUMO_TIER_2 = 'appsumo-tier-2',
  APPSUMO_TIER_3 = 'appsumo-tier-3',
  ENTERPRISE = 'enterprise',
}

export enum PaddlePlanType {
  STARTER = PlanType.STARTER,
  PRO = PlanType.PRO,
  PRO_PLUS_VOICE = PlanType.PRO_PLUS_VOICE,
}

export enum PlanBillingCycle {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export const BILLING_MODES = {
  MONTHLY: PlanBillingCycle.MONTHLY,
  YEARLY: PlanBillingCycle.YEARLY,
}

export const SOFT_LOCKED_BLOCKED_PATHS = [
  '/dashboard/training',
  '/dashboard/appearance',
  '/dashboard/install',
  '/dashboard/wordpress',
  '/dashboard/facebook',
  '/dashboard/developer',
]
